import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { inductionCeremonySections } from "../data/inductionCeremony";
import "./InductionDayCeremony.css";

export default function InductionDayCeremony() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title =
      "Induction Day Ceremony | Takshashila Medical College & Hospital";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <article className="induction-page">
      <header className="induction-header">
        <div className="univ-wrap">
          <nav aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span aria-hidden="true">/</span>
            <span aria-current="page">Induction Day Ceremony</span>
          </nav>
          <p className="induction-eyebrow">
            TAKSHASHILA MEDICAL COLLEGE & HOSPITAL
          </p>
          <h1>Induction Day Ceremony</h1>
          <p className="induction-lead">
            Welcoming our new MBBS students to medical education and clinical
            practice.
          </p>
        </div>
      </header>
      <div className="univ-wrap induction-layout">
        <aside className="induction-sidebar">
          <nav aria-label="Ceremony programme">
            <p className="induction-eyebrow">THE CEREMONY</p>
            <ol>
              {inductionCeremonySections.map((section) => (
                <li key={section.id}>
                  <a href={`#${section.id}`}>
                    {section.title}
                    {section.speaker && <span>{section.speaker}</span>}
                  </a>
                </li>
              ))}
            </ol>
          </nav>
        </aside>
        <div className="induction-article">
          {inductionCeremonySections.map((section, index) => (
            <section
              id={section.id}
              className="induction-address"
              key={section.id}
              aria-labelledby={`${section.id}-title`}
            >
              <span className="induction-number">
                {String(index + 1).padStart(2, "0")}
              </span>
              <h2 id={`${section.id}-title`}>{section.title}</h2>
              {section.speaker && (
                <div className="induction-speaker">
                  <h3>{section.speaker}</h3>
                  <p>{section.role}</p>
                </div>
              )}
              <figure className="induction-photo">
                <img
                  src={section.image}
                  alt={`${section.title} at the Induction Day Ceremony`}
                  width={section.imageWidth}
                  height={section.imageHeight}
                  loading={index === 0 ? "eager" : "lazy"}
                  decoding="async"
                />
              </figure>
              <p className="induction-copy">{section.text}</p>
            </section>
          ))}
          <div className="induction-end">
            <Link to="/">
              <ArrowLeft size={16} /> Back to home
            </Link>
            <Link to="/courses-mbbs">
              Explore the MBBS programme <ArrowUpRight size={17} />
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
}
